import React from 'react'
import Footer from '../../Footer'
import bg from '../../../img/id/flake/bg.png'
import logo from '../../../img/id/flake/logo.png'
import fig1 from '../../../img/id/flake/1.png'
import fig2 from '../../../img/id/flake/2.png'

import '../Proj.css'

export default class ProjFlake extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div id='flake-title'>
                    <img src={logo} />
                    <h1>Chair Design</h1>
                    <p>Under supervision of Prof. Ming-Huang Lin.</p>
                </div>
                <div className='proj-bg'>
                    <img src={bg} />
                </div>
                <div className='proj-fig1'>
                    <img src={fig1} />
                </div>
                <p className='little-title'>Made out of one single flat acrylic sheet</p>
                <div className='proj-content'>
                    <div className='proj-side2side'>
                        <p>
                        The challenge of making a chair is always about bringing different materials into play while maintaining the human factors and weight enduring. I tackled this challenge by using the mostly used material in our lab (HCI lab in NTU), acrylic. To me, laser-cutting is one of the most efficient ways to make things. The clearness and easiness to bend with heat are also features I want to utilize in this design. So here I present Flake, a chair completely made out of one single flat sheet of acrylic, with two horizontal joints that ensure strength.
                        <br/>
                        The prototype is made of thick acrylic, while in the real case, metal is also suitable for this design. And by adjusting the size of the laser-cut piece, it can come in different sizes, making it ideal for children.

                        </p>
                    </div>
                    <div className='proj-side2side'>
                        <div className='proj-fig'>
                            <img src={fig2} />
                        </div>
                    </div>
                    
                </div>
                <Footer back={true}/>
            </div>
        )
    }
}